/*
    Indicate if the current runtime is a browser (or mock browser)
*/

export default function isBrowser() {
  return typeof window !== 'undefined'
}
